module.exports = __webpack_public_path__ + "static/media/hero-image-2.d0fbdb86.png";